// function addMaskToImages(event) {
//     const img = event.target;
//     console.log(img.closest("main"));
//     if (!img.closest("main") || img.dataset.maskApplied) return;

//     const randomNumber = Math.floor(Math.random() * 9000000000) + 1000000000;
//     const svg = document.createElement("svg");
//     svg.setAttribute("class", "bezier-curve card-img-top lazyloaded");
//     svg.setAttribute("viewBox", "0 0 2048 1366");
//     img.setAttribute("mask", `url(#image-mask-${randomNumber})`);
//     img.dataset.maskApplied = "true";
//     img.setAttribute("width", img.offsetWidth);
//     img.setAttribute("height", img.offsetHeight);
//     let imageString = img.outerHTML.replace(/img/g, "image");

//     console.log(imageString);

//     svg.innerHTML = `
//     <defs>
//         <mask id="image-mask-${randomNumber}">
//             <path fill="white" d="m0,204.8 q0,-204.8 204.8,-204.8 l1638.4, 102.4 q204.8,0 204.8, 204.8 l0, 751.5999999999999 q0, 204.8 -204.8, 204.8 l-1638.4, 0 q-204.8, 0 -204.8,-204.8 l0,-956.4z"></path>
//         </mask>
//         ${imageString}
//     </defs>
//     `;

//     // Replace img with svg
//     img.parentNode.replaceChild(svg, img);
// }

(function () {
    if (typeof document !== 'undefined') {
        // document.addEventListener('lazyloaded', addMaskToImages);

        var events = [
            'constructor.color-module',
        ];
        events.forEach((eventName) => {
            document.addEventListener(eventName, (event) => {
                console.log('event listener in jb-nexus, for event name', eventName);
                switch (eventName) {
                    case 'constructor.color-module':
                        var module = event.data;
                        if (module.configuration) {
                            console.log('module configuration', module.configuration);
                            module.configuration = {
                                // mode: 'dynamic-dark', // set specifically,
                            };
                        }
                        break;

                    default:
                        break;
                }
                // if (event.data) {
                //     console.log(eventName, 'was triggered, containing event data', event, event.data);
                //     event.data = {test: '123'};
                // }
            });
        });
    }
})()